import { render } from "./AddOrEditProductPage.vue?vue&type=template&id=70612776&ts=true"
import script from "./AddOrEditProductPage.vue?vue&type=script&lang=ts"
export * from "./AddOrEditProductPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__